import { useCallback } from 'react';

import { useSubmitPromoCodeMutation } from './graphql/SubmitPromoCode.generated';

export const useSubmitPromoCode = () => {
  const [submitCodeResponse, submitPromoCodeMutation] = useSubmitPromoCodeMutation();

  const submitCode = useCallback(
    async (code: string) => {
      const { data, error } = await submitPromoCodeMutation({
        input: { code },
      });

      const typename = data?.submitPromoCode?.__typename;
      const isSubmitSuccess = typename === 'SubmitPromoCodeSuccessV2';

      const isAlreadyApplied = data?.submitPromoCode?.__typename === 'PromoCodeAlreadyApplied';

      return { isSubmitSuccess, data, typename, error, isAlreadyApplied };
    },
    [submitPromoCodeMutation],
  );

  return { submitCodeResponse, submitCode };
};
